import React, { useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Footer from './components/Footer';
import CoinDropCountdown from './components/Counter';
// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent } from 'firebase/analytics';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAhSu5dOtbJYyAcdA0uVPO1dokUbesVg8E",
  authDomain: "sharkkid-home.firebaseapp.com",
  projectId: "sharkkid-home",
  storageBucket: "sharkkid-home.firebasestorage.app",
  messagingSenderId: "23403283768",
  appId: "1:23403283768:web:499e67a6325cc1716aadcd",
//  measurementId: "G-H1YGRNV68T"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics and get a reference to the service
const analytics = getAnalytics(app);

// ... assuming 'analytics' is already initialized as shown above

// Example: Log a screen view when a specific page/component is displayed
function logScreenView(screenName, className = 'App') {
  if (analytics) { // Check if analytics was successfully initialized
    logEvent(analytics, 'screen_view', {
      firebase_screen: screenName, // Use 'firebase_screen' parameter for screen name
      firebase_screen_class: className // Optional: Add screen class (e.g., component name)
    });
  }
}

function App() {

	useEffect(() => {
		logScreenView('Home')
	}, []);
  return (
    <>
      <Header handleNavClick={(screenName) => {logScreenView(screenName, 'Header')}} />
      <main>
        <Hero />
        {/* About Section */}
        <section id="about" className="section">
          <div className="container">
            <h2>About SharkKid</h2>
            <p style={{ fontSize: '1.1rem', maxWidth: '800px', margin: '0 auto', color: '#cbd5e0' }}>
              SharkKid is more than just a cryptocurrency; it's a community-driven movement aiming to make a splash in the decentralized finance world. Our goal is to create a fun, engaging, and rewarding environment for our holders. Join us as we build a strong foundation and ride the waves to success!
            </p>
          </div>
        </section>
        {/* Roadmap Section */}
        <section id="roadmap" className="section" style={{ backgroundColor: '#2d3748' }}>
          <div className="container">
            <h2>Roadmap</h2>
            <div className="flex-row">
              <div className="flex-item">
                <h3>Phase 1: Community Building</h3>
                <ul>
                  <li>Initial marketing push</li>
                  <li>Community growth on Telegram and X</li>
                  <li>Website launch</li>
                </ul>
              </div>
              <div className="flex-item">
                <h3>Phase 2: Expansion</h3>
                <ul>
		  <li>Twitch streaming</li>
		  <li>Further community growth</li>
                  <li>Influencer collaborations</li>
                  <li>Exploring potential partnerships</li>
                </ul>
              </div>
              <div className="flex-item">
                <h3>Phase 3: Utility & Ecosystem (Future)</h3>
                <ul>
		  <li>Token launch <strong>June 20th</strong>!</li>
                  <li>Coingecko/CoinMarketCap listings (after launch)</li>
                  <li>Further exchange listings</li>
                  <li>And much more!</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Community Section */}
        <section id="community" className="section">
          <div className="container">
            <h2>Join Our Community</h2>
            <p style={{ fontSize: '1.1rem', maxWidth: '800px', margin: '0 auto', color: '#cbd5e0' }}>
              The strength of SharkKid lies in its community. Connect with fellow SharkKids, get the latest updates, and participate in discussions on our official channels.
            </p>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '1.5rem', marginTop: '2rem' }}>
              <a href="https://t.me/+MwezxqE66qU4NGIx" target="_blank" rel="noopener noreferrer" className="btn">Telegram</a>
              <a href="https://x.com/SharkKidSK" target="_blank" rel="noopener noreferrer" className="btn">X</a>
              <a href="mailto:sharkkidsk@gmail.com" className="btn">Email</a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default App;